/**
 * Each GameName value must match the corresponding BO config group name,
 * as it's also used to access specific configuration attributes.
 * Ensure consistency when updating or adding new GameName entries.
 */

export enum GameName {
  OneDayTeenPatti = 'OneDayTeenPatti',
  ThreeCardPoker = 'threecardpoker',
  AndarBahar = 'andar-bahar',
  Baccarat = 'baccarat',
  BlackJack = 'blackjack',
  BetOnTeenPatti = 'Bet_On_Teen_Patti',
  CasinoHoldem = 'casinoholdem',
  Lucky7 = 'lucky7',
  Lobby = 'lobby',
  Matka = 'matka',
  MarbleRace = 'MarbleRace',
  BigCockKnockout = 'BigCockKnockout',
  Roulette = 'roulette',
  SicBo = 'sic_bo',
  UltimateDice = 'Ultimate_Dice',
  XocDia = 'XocDia',
}
